module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/define-property.js
// module id = 55
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460